export default "__VITE_ASSET__DS9ZJRxG__"